'use strict';

angular.module('dekky.forms.themes.far')
	.run(function($templateCache) {
		$templateCache.put('/dekky.forms/themes/far/fields/mountainPeakSelect.html',
			'<ui-select class="form__ui-select" ng-model="model" id="{{ field.name }}" name="{{ field.name }}" on-select="field.uiSelectOptions.onSelect($item, $model, $select.ngModel.$options)">' +
				'<ui-select-match class="ui-select-match" placeholder="Введите вершину..."><span ng-bind="$select.selected.name"></span></ui-select-match>' +
				'<ui-select-choices ' +
					'class="ui-select-choices"' +
					'repeat="item in field.items track by item.id"' +
					'refresh="field.uiSelectOptions.refreshAutoComplete($select.search, \'MountainPeak\', \'mountainPeaks\')"' +
					'refresh-delay="0"' +
				'><span ng-bind="item.name"></span><span ng-bind="item.region_name"></span><span ng-bind="item.area_name"></span></ui-select-choices>' +
			'</ui-select>'
		);
	});